import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.873}
    height={14.873}
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:#00446e}"}</style>
    </defs>
    <g
      id="Group_868"
      data-name="Group 868"
      transform="translate(-616.465 -562)"
    >
      <path
        id="Path_211"
        data-name="Path 211"
        className="cls-1"
        d="m111.878 213.8-6.073 4.09a.672.672 0 0 1-.682 0l-6.135-4.09a.638.638 0 0 0-.992.5v8.18a.585.585 0 0 0 .62.62h13.634a.585.585 0 0 0 .62-.62v-8.12a.663.663 0 0 0-.992-.558z"
        transform="translate(518.469 353.775)"
      />
      <path
        id="Path_212"
        data-name="Path 212"
        className="cls-1"
        d="M191.3 28h-8.68a.585.585 0 0 0-.62.62v4.028a.765.765 0 0 0 .248.5l4.338 2.913a.672.672 0 0 0 .682 0l4.338-2.913a.632.632 0 0 0 .31-.5V28.62a.585.585 0 0 0-.62-.62zm-2.479 4.152h-1.549V33.7a.31.31 0 1 1-.62 0v-1.548H185.1a.31.31 0 1 1 0-.62h1.549v-1.549a.31.31 0 1 1 .62 0v1.549h1.549a.31.31 0 1 1 0 .62z"
        transform="translate(436.944 534)"
      />
    </g>
  </svg>
)

export default SvgComponent